import React from "react";
import { Snackbar, Alert } from "@mui/material";

const MessagePopup = ({ message, severity, open, setPopup }) => {
    return (
      <Snackbar
        open={open}
        autoHideDuration={3000}
        onClose={() => setPopup((prev) => ({ ...prev, open: false }))}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          severity={severity}
          sx={{ width: "100%" }}
          onClose={() => setPopup((prev) => ({ ...prev, open: false }))}
        >
          {message}
        </Alert>
      </Snackbar>
    );
  };
  
  export default MessagePopup